/**
 * @file AppProviders.jsx
 * @description Wraps the app in all required React context providers.
 * Provider order matters: MsalProvider → UserProvider → NotificationProvider.
 *
 * FDD rationale: provider composition is its own concern.
 * Adding a new provider = edit ONE file, never touch App.jsx.
 */

import React from 'react';
import { MsalProvider } from '@azure/msal-react';
import { UserProvider } from '../components/UserContext';
import { NotificationProvider } from '../contexts/NotificationContext';
import { Toaster } from 'sonner';

const AppProviders = ({ instance, children }) => (
  <MsalProvider instance={instance}>
    <UserProvider>
      <NotificationProvider>
        {children}
        <Toaster richColors closeButton position="top-right" />
      </NotificationProvider>
    </UserProvider>
  </MsalProvider>
);

export default AppProviders;